/**
 * @description Hook to get the unread notifications count
 * @param {UseNotificationsOptions} options - The options for the hook
 * @returns {UseQueryResult<NotificationsResponse>} - The unread notifications count
 */

import { useQuery } from "@tanstack/react-query";
import { NOTIFICATIONS_QUERY_KEY, NOTIFICATIONS_STALE_TIME } from "@/features/notifications/constants/notifications.constants";
import { notificationsService } from "@/features/notifications/services/notifications.service";
import type { NotificationsResponse } from "@/features/notifications/types/notifications.type";

type UseNotificationsOptions = {
  enabled?: boolean
  pathname?: string
};

export const useNotifications = (options?: UseNotificationsOptions) => {
  const queryKey = options?.pathname
    ? [...NOTIFICATIONS_QUERY_KEY, options.pathname]
    : NOTIFICATIONS_QUERY_KEY;

  return useQuery<NotificationsResponse>({
    queryKey,
    queryFn: notificationsService.getUnreadCounts,
    enabled: options?.enabled ?? true,
    refetchOnWindowFocus: true,
    staleTime: NOTIFICATIONS_STALE_TIME,
  });
};
